import { TestChatTab } from '@/features/ai/TestChatTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/ai/test-chat')({
  component: TestChatTab,
});
